import type { IFontSize } from "@interfaces/styles";

export const fontSizeToPx = (font: IFontSize) => {
  try {
    return Number(font?.split("-")[1]);
  } catch {
    return 16;
  }
};

export const fontSizeToRem = (font: IFontSize) => {
  return fontSizeToPx(font) / 16;
};
